import React from 'react';

const RedirectToExternal: React.FC<{ url: string }> = ({ url }) => {
  window.location.href = url;
  return null; // No need to render anything
};

export default RedirectToExternal;